import { Typography } from "@packages/ds";
import styled from "styled-components";

import * as Table from "ds/Table";
import { semiBoldAlias } from "Libs/theme";

export const Wrapper = styled.section`
  margin: 26px 0 0 0;
`;

export const TitleHead = styled(Typography.Title)`
  margin-bottom: 11px;
`;

export const BodyText = styled(Typography.BodyText)`
  margin-left: 5px;
  font-size: inherit;
  display: inline;
`;

export const Cell = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  color: var(--section-periwinkle-grey-color, var(--periwinkle-grey));
  font-size: 15px;

  > a {
    text-decoration: none;
  }
  > a > span {
    color: var(--button-color-primary-600-color, var(--color-primary-600));
  }
  > a > span:hover {
    color: var(--button-color-primary-600-color, var(--color-primary-600));
    text-decoration: underline;
  }
`;

export const Title = styled.span`
  color: var(--section-ebony-light-color, var(--ebony-light));
  ${semiBoldAlias()};
`;

export const Hr = styled.hr`
  margin: 5px 0 16px 0;
  background-color: var(--mode-border-neutral-weakest);
`;

export const TableTable = styled(Table.Table)`
  background-color: var(--mode-bg-neutral-weakest);
  padding: 13px 32px 32px;
  margin-top: 8px;
`;
export const TableThead = styled(Table.Thead)`
  display: grid;
  grid-template-columns: 21.2% 30% 44%;
  grid-row-gap: 14px;
  grid-column-gap: 16px;
  padding: 0;
`;

export const RowLeftLayout = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;

  img + span {
    margin-left: 16px;
  }
`;
